<template>
  <a-dropdown v-if="currentUser && currentUser.nickname" class="ant-pro-dropdown ant-pro-dropdown-action"
    placement="bottomRight" overlayClassName="pro-components-header-dropdown-index-container">
    <span>
      <a-avatar size="small" :src="currentUser.avatar" class="ant-pro-header-account-avatar"
        v-if="currentUser.avatar" />
      <a-avatar v-else size="small" class="ant-pro-header-account-avatar">
        <template #icon>
          <UserOutlined />
        </template>
      </a-avatar>
      <span class="ant-pro-header-account-name anticon" style="color: #ffffff;">{{ currentUser.nickname }}</span>
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-dropdown-menu" :selected-keys="[]">
        <!-- <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <template #icon><setting-outlined /></template>
          个人设置
        </a-menu-item> -->
        <a-menu-item v-if="menu" key="changePw" @click="changePw">
          <template #icon><lock-outlined /></template>
          修改密码
        </a-menu-item>
        <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <template #icon><setting-outlined /></template>
          个人设置
        </a-menu-item>
        <a-menu-divider v-if="menu" />
        <a-menu-item key="logout" @click="handleLogout">
          <template #icon><logout-outlined /></template>
          退出登录
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>
  <a-modal v-model:visible="changePwVisible" title="修改密码" @ok="handleChangePwOk" @cancle="handleChangePwCancel"
    footer="">
    <a-form ref="formRef" name="custom-validation" :model="formState" :rules="rules" v-bind="layout"
      @finish="handleFinish" @validate="handleValidate" @finishFailed="handleFinishFailed">
      <a-form-item  label="旧密码" name="currentPassword">
        <a-input v-model:value="formState.currentPassword" type="password" autocomplete="off" />
      </a-form-item>
      <a-form-item has-feedback label="新密码" name="newPassword">
        <a-input v-model:value="formState.newPassword" type="password" autocomplete="off" />
      </a-form-item>
      <a-form-item has-feedback label="再次输入新密码" name="checkPass">
        <a-input v-model:value="formState.checkPass" type="password" autocomplete="off" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
        <a-button @click="handleChangePwCancel" style="margin-left: 30px">取消</a-button>
        <a-button @click="handleChangePwOk" style="margin-left: 20px" type="primary" html-type="submit"
          :loading="changePwLoading" :disabled="disabledChangePw">确认修改</a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { computed, defineComponent, h, reactive, ref } from 'vue';
import { SettingOutlined, LogoutOutlined, LockOutlined, UserOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { LOGOUT } from '@/store/modules/user/actions';
import type { FormInstance, Rule } from 'ant-design-vue/lib/form';
import type { AxiosResponse } from '@/utils/request';
import request from '@/utils/request';
import { encodeByPublicKey } from '@/utils/ras-service';
import { message, Modal } from 'ant-design-vue';
interface FormState {
  currentPassword: string;
  checkPass: string;
  newPassword: string;
}
export default defineComponent({
  name: 'AvatarDropdown',
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
    menu: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    const changePwVisible = ref(false);
    const changePwLoading = ref(false);
    const formRef = ref<FormInstance>();
    const formState = reactive<FormState>({
      currentPassword: '',
      checkPass: '',
      newPassword: '',
    });
    const handleToCenter = () => {
      router.push({ path: '/account/center' });
    };
    const handleToSettings = () => {
      router.push({ path: '/account/settings' });
    };
    const handleLogout = () => {
      store.dispatch(`user/${LOGOUT}`).then(() => {
        router.push({ path: '/user/login' });
      });
    };
    const changePw = () => {
      changePwVisible.value = true;
    };
    const disabledChangePw = computed(() => {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{6,20}$/;
      return  !regex.test(formState.newPassword) ||  !(formState.currentPassword && formState.checkPass && formState.newPassword && formState.checkPass==formState.newPassword);
    });
    const handleChangePwOk = () => {
      changePwLoading.value = true;
      request.post<any, AxiosResponse<any>>('/thsuaa/api/sys-users/change-password', {
        currentPassword: encodeByPublicKey(formState.currentPassword),
        newPassword: encodeByPublicKey(formState.newPassword),
      }).then(() => {
        changePwVisible.value = false;
        changePwLoading.value = false;
        formRef.value.resetFields();
        Modal.success({
        title: '密码修改成功',
        content: h('div', {}, [
            h('p', '请妥善保管好新密码，下次登录和修改密码时请使用新密码'),
          ]),
        });
      }).catch((error) => {
          if(error.title){
            message.error(error.title);
          }else{
            message.error('修改密码时出错，请检查原密码是否正确，以及新密码是否符合要求');
          }
          changePwLoading.value = false;
        });
    };

    const handleChangePwCancel = () => {
      changePwVisible.value = false;
      formRef.value.resetFields();
    };
    // === 生成所有长度为3的连续子串（正向 + 反向），输出小写 ===
    function getTriplets(str: string): Set<string> {
      const triplets = new Set<string>();
      for (let i = 0; i <= str.length - 3; i++) {
        const forward = str.slice(i, i + 3);
        const backward = forward.split('').reverse().join('');
        triplets.add(forward);    // str 已是小写，直接加入
        triplets.add(backward);
      }
      return triplets;
    }
    let checkNewPassword = async (_rule: Rule, value: string) => {
      if (!value) {
        return Promise.reject('请输入新密码');
      } else {
        // 修改正则：要求至少包含大写字母、小写字母、特殊符号，长度至少8位
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,20}$/;
        if (!pattern.test(value)) {
          return Promise.reject('密码8-20位，必须包含大小写字母、数字和特殊符号');
        }
        // 1. 检查连续数字（正向和反向）
        const consecutiveDigits = [
          '012', '123', '234', '345', '456', '567', '678', '789',
          '987', '876', '765', '654', '543', '432', '321', '210',
        ];
        for (let seq of consecutiveDigits) {
          if (value.includes(seq)) {
            return Promise.reject('密码不能包含连续数字（如 123、765 等）');
          }
        }

        // === 统一使用小写进行匹配 ===
        const lowerValue = value.toLowerCase();

        // === 1. 横向行（全部小写）===
        const horizontalRows = [
          '1234567890-=',
          '!@#$%^&*()_+',
          'qwertyuiop[]\\',
          'asdfghjkl;',
          'zxcvbnm,./'
        ];

        // === 2. 纵向列（从上到下，全部小写）===
        // 正常状态（数字/字母）
        const verticalCols = [
          '1qaz',
          '2wsx',
          '3edc',
          '4rfv',
          '5tgb',
          '6yhn',
          '7ujm',
          '8ik,',
          '9ol.',
          '0p;/'
        ];

        // Shift 状态：符号 + 小写字母（关键：全部小写！）
        const shiftedVerticalCols = [
          '!qaz',   // Shift+1 → q → a → z
          '@wsx',   // Shift+2 → w → s → x
          '#edc',
          '$rfv',
          '%tgb',
          '^yhn',
          '&ujm',   // & → u → j → m
          '*ik<',   // * → i → k → < (Shift + ,)
          '(ol>',
          ')p?/'
        ];

        // === 收集所有禁止的三字符组合（小写）===
        const forbidden = new Set<string>();

        // 添加横向
        for (const row of horizontalRows) {
          const seqs = getTriplets(row);
          seqs.forEach(s => forbidden.add(s));
        }

        // 添加纵向（正常）
        for (const col of verticalCols) {
          const seqs = getTriplets(col);
          seqs.forEach(s => forbidden.add(s));
        }

        // 添加纵向（Shift 状态）
        for (const col of shiftedVerticalCols) {
          const seqs = getTriplets(col);
          seqs.forEach(s => forbidden.add(s));
        }

        // === 检查输入（小写）是否包含任意禁止序列 ===
        for (const seq of forbidden) {
          if (lowerValue.includes(seq)) {
            return Promise.reject(`密码不能包含键盘连续字符（如 "${seq}"）`);
          }
        }
      }
      return Promise.resolve(); // 显式返回 resolve，避免 undefined
    };
    let validatePass = async (_rule: Rule, value: string) => {
      if (value === '') {
        return Promise.reject('请输入旧密码');
      }
    };
    let validatePass2 = async (_rule: Rule, value: string) => {
      if (value === '') {
        return Promise.reject('请再次输入新密码');
      } else if (value !== formState.newPassword) {
        return Promise.reject('两次新密码输入不一致！');
      } else {
        return Promise.resolve();
      }
    };

    const rules: Record<string, Rule[]> = {
      currentPassword: [{ required: true, validator: validatePass, trigger: 'change' }],
      checkPass: [{ required: true, validator: validatePass2, trigger: 'change' }],
      newPassword: [{ required: true, validator: checkNewPassword, trigger: 'change' }],
    };
    const layout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
    };
    const handleFinish = (values: FormState) => {
      console.log(values, formState);
    };
    const handleFinishFailed = errors => {
      console.log(errors);
    };
    const handleValidate = (...args) => {
      console.log(args);
    };

    return {
      t,
      handleToCenter,
      handleToSettings,
      handleLogout,
      changePw,
      handleChangePwOk,
      handleChangePwCancel,
      changePwVisible,
      changePwLoading,
      formState,
      formRef,
      rules,
      layout,
      disabledChangePw,
      handleFinishFailed,
      handleFinish,
      handleValidate,
    };
  },
  components: {
    LockOutlined,
    SettingOutlined,
    LogoutOutlined,
    UserOutlined
  },
});
</script>

<style lang="less">
body {
  @import './header-dropdown.less';
  .ant-pro-header-account-name {
    vertical-align: unset;
  }
  .ant-pro-header-account-avatar {
    margin: 12px 8px 12px 0;
    color: @primary-color;
    vertical-align: top;
    background: hsla(0, 0%, 100%, 0.85);
  }
}
</style>
